"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRemoteVideoPlayerConfig = exports.defaultVideoPlayerConfig = exports.defaultLeaveChannelOptions = void 0;
exports.defaultLeaveChannelOptions = {
    stopAudioMixing: true,
    stopAllEffect: true,
    stopMicrophoneRecording: true,
};
exports.defaultVideoPlayerConfig = {
    fit: 'contain',
    mirror: false,
};
exports.defaultRemoteVideoPlayerConfig = {
    fit: 'cover',
    mirror: false,
};
